import { TeamModel } from 'types';

// cSpell: disable
export const BASE_FB_STORAGE_URL = 'https://firebasestorage.googleapis.com/v0/b/squares-4fef3.firebasestorage.app/o/';
const L01 = 'squares-logos%2Fsquares-logo.webp?alt=media&token=792c0d9a-50bd-4647-9c37-3346b5090ffa';
const L11 = 'squares-logos%2Fsquares-logo-v11.webp?alt=media&token=ba11ac95-bc13-4f13-911b-571304936b7e';
const L12 = 'squares-logos%2Fsquares-logo-v12.webp?alt=media&token=b2244a51-9b94-49e5-be22-7d6b775844c3';
export const LOGO_01 = `${BASE_FB_STORAGE_URL}${L01}`;
export const LOGO_11 = `${BASE_FB_STORAGE_URL}${L11}`;
export const LOGO_12 = `${BASE_FB_STORAGE_URL}${L12}`;

export const FALLBACK_LOGO = '/images/nfl/logos/app/skeleton-72x72.webp';

export const DESKTOP_VERTICAL_BAR_HEIGHT_LARGE = 500;
export const DESKTOP_VERTICAL_BAR_HEIGHT_SMALL = 280;
export const MOBILE_VERTICAL_BAR_HEIGHT = 250;
export const MOBILE_HORIZONTAL_BAR_WIDTH = 210;
export const DESKTOP_HORIZONTAL_BAR_WIDTH_SMALL = 250;
export const MOBILE_HORIZONTAL_BAR_WIDTH_LARGE = 280;

export const GREEN_COLOR = '#4eff00';
export const RED_COLOR = '#e20000';
export const GRAY_COLOR = '#808080';

export const HELMET_LOGO_PATH = 'images/nfl/logos/app/';

export const HelmetImageName = {
  Logo1000: 'nflstats-helmet-logo-1000x1000',
  Logo640: 'nflstats-helmet-logo-640x640',
  Logo360: 'nflstats-helmet-logo-360x360',
  Logo320: 'nflstats-helmet-logo-320x320',
  Logo240: 'nflstats-helmet-logo-240x240',
  Logo120: 'nflstats-helmet-logo-120x120',
  Logo96: 'nflstats-helmet-logo-96x96',
  Logo64: 'nflstats-helmet-logo-64x64',
} as const;

// cSpell: enable
export const ImageURL = {
  CoralReef: 'images/coral-reef.webp',
  AppBg: 'images/bg-distorted-mesh.webp',
  AppLogo: 'images/logo.webp',
  HelmetLogo1000: `${HELMET_LOGO_PATH}${HelmetImageName.Logo1000}`,
  HelmetLogo640: `${HELMET_LOGO_PATH}${HelmetImageName.Logo640}`,
  HelmetLogo360: `${HELMET_LOGO_PATH}${HelmetImageName.Logo360}`,
  HelmetLogo320: `${HELMET_LOGO_PATH}${HelmetImageName.Logo320}`,
  HelmetLogo240: `${HELMET_LOGO_PATH}${HelmetImageName.Logo240}`,
  HelmetLogo120: `${HELMET_LOGO_PATH}${HelmetImageName.Logo120}`,
  HelmetLogo96: `${HELMET_LOGO_PATH}${HelmetImageName.Logo96}`,
  HelmetLogo64: `${HELMET_LOGO_PATH}${HelmetImageName.Logo64}`,
} as const;

export const AnimationCls = {
  CloseCard: 'swing-out-top-bck',
  OpenCard: 'swing-in-top-fwd',
};

export const patternsArray = [
  'absurdity',
  'assault',
  'blackOrchid',
  'creamPaper',
  'crissxcross',
  'cubes',
  'darkDenim',
  'fabricDark45Degree',
  'fabricOfSquares',
  'fakeBrick',
  'fakeLuxury',
  'grayLines',
  'greenFibers',
  'gridNoise',
  'groovePaper',
  'hexellence',
  'paper1',
  'purtyWood',
  'snow',
  'tex2res3',
  'tile3px',
  'waveGrid',
  'whiteBedSheet',
  'whiteBrushed',
  'whiteLeather',
  'whitePaperboard',
  'whiteWall',
  'whitey',
  'brickWallDark',
  'brickWall',
  'honeyImSubtle',
  'tileableWood',
  'darkWood',
  'retinaWood',
  'cartographer',
  'footballNoLines',
  'carbonFiber',
  'carbonFiberBig',
];
export const TOTAL_FRAME_PATTERNS = patternsArray.length;

// #region LOG COLOR STYLES ***************************************************

// cSpell:enableCompoundWords
// #region LOG COLORS
// dodgerblue     = #1E90FF;
// cornsilk       = #FFF8DC;
// darkolivegreen = #556B2F;
// palegreen      = #98FB98;
// darkgreen      = #006400;
// crimson        = #DC143C;
// ivory          = #FFFFF0;
// whitesmoke     = #F5F5F5;
//

export type ColorStyleClsType = {
  bg: string;
  color: string;
  weight?: number;
  style?: 'normal' | 'italic';
};

const baseStyle = 'padding: 0 2px; border: thin solid; border-radius: 40px; text-align: center;';

/**
 * Generates a custom CSS style for `console.log` color bubble
 * @param param `{ColorStyleClsType} { bg, color, weight, style }`
 * ```
 * export type ColorStyleClsType = {
 *  bg: string;
 *  color: string;
 *  weight?: number; // 100..900 default 400
 *  style?: 'normal' | 'italic'; // default 'normal'
 *  };
 *```
 * @returns {string} CSS style string that should be applied similar to
 * ```
 * const customStyle = getColorCls({bg: '#000000', color: '#FFFFFF', weight: 600, style: 'italic'});
 * console.log('some text %c highlight bubble %c', customStyle, '');
 * // the last "%c" gets assigned an empty quote to stop the style from expanding to the next console.log line
 * ```
 */
export const getColorCls = ({ bg, color, weight = 400, style = 'normal' }: ColorStyleClsType): string => {
  return `${baseStyle} background: ${bg}; border-color: ${bg};
          color: ${color}; font-weight: ${weight}; font-style: ${style};`;
};

const colorCls = (style: string) => {
  const bgColor = style.trim().slice(12, 20);
  return `${baseStyle} border-color: ${bgColor}; ${style}`;
};

const altCrCls = (style: string, borderColor = '#a7a47d') => {
  return `${baseStyle} border-color: ${borderColor}; ${style}`;
};

export const BurlywoodCls = colorCls('   background: #f0d8ba; color: #121212; font-weight: 700;');
export const DodgerBlueCls = colorCls('  background: #1e90ff; color: #fff8dc;');
export const InfoCls = colorCls('        background: #a9d4ff; color: #000000; font-weight: 600;');
export const ArmyGreenCls = colorCls('   background: #556b2f; color: #fff4b7;');
export const PaleGreenCls = altCrCls('   background: #98fb98; color: #000000;', '#014b04');
export const CrimsonCls = colorCls('     background: #dc143c; color: #fff8dc; font-weight: 700;');
export const CountDisplayCls = colorCls('background: #2a0077; color: #d3fffd;');
export const ValueCls = colorCls('       background: #ffa048; color: #000000;');
export const ValueLgCls = colorCls('     background: #ffa048; color: #000000; font-weight: 700; font-size: 14px;');
export const LocationCls = altCrCls('    background: #163051; color: #ffcc00; font-size: 12px; font-weight: 600;');
export const MessageCls = altCrCls('     background: #fded02; color: #2b2200; font-weight: 600;', '#a7a47d');
export const ActionCls = altCrCls('      background: #e1ffac; color: #475932; font-size: 12px;', '#475932');
export const RequestCls = colorCls('     background: #376203; color: #fff8dc; font-weight: 600;');
export const DarkGrayCls = colorCls('    background: #333333; color: #fff8dc;');
export const DarkGreenCls = colorCls('   background: #006400; color: #fff8dc; font-style: italic;');
// export const END = '\x1B[m';
export const END = ''; // This doesn't work in browser consoles
// #endregion

export const Cls = {
  Act: ActionCls,
  Army: ArmyGreenCls,
  Bur: BurlywoodCls,
  Cnt: CountDisplayCls,
  Cri: CrimsonCls,
  DBl: DodgerBlueCls,
  DrkGn: DarkGreenCls,
  DrkGr: DarkGrayCls,
  Info: InfoCls,
  Loc: LocationCls,
  Msg: MessageCls,
  Pale: PaleGreenCls,
  Req: RequestCls,
  Val: ValueCls,
  ValLg: ValueLgCls,
};

// #region EMOJI/CHARS NAMES
export const Emojis = {
  addPlayer: '♟',
  addScore: '⚔',
  admin: '⚗',
  asterisk: '🞿',
  calendar: '🗓️',
  cancel: '✘',
  checkBox: '✅',
  checkMark: '✔️',
  close: '🞬',
  delete: '🗑️',
  ex: '❌',
  exGrey: '✖️',
  eye: '👁️',
  eyes: '👀',
  fingerUp: '☝️',
  fingerDown: '👇',
  fingerLeft: '👈',
  fingerRight: '👉',
  fullWindow: '🗖',
  football: '🏈',
  gear: '⚙️',
  hammers: '⚒️',
  hourglass: '⌛',
  heartOn: '♥',
  heartOff: '♡',
  info: 'ℹ️',
  load: '⏳',
  lockBoard: '🗝',
  location: '📍',
  mail: '✉️',
  mailNew: '📬',
  ok: '✔',
  options: '⏣', // '⌬', // ⚙️
  party: '🎉',
  pencil: '✏️',
  plus: '➕',
  print: '⌨', //'🖨️',
  question: '❓',
  redBrick: '⛔️',
  rocketInit: '🛰',
  rocket: '🚀',
  run: '🏇',
  safety: '🛡',
  save: '💾',
  share: '☍',
  shieldOn: '🛡️',
  shieldOff: '⛉',
  skull: '☠️',
  small: '▦',
  squares: '⧉',
  big: '▣',
  speak: '💬',
  target: '🎯',
  thumbsUp: '👍',
  transactionStart: '📃',
  transactionSuccess: '📑',
  transactionComplete: '📜',
  threeDots: '⠇',
  voiceAmp: '📣',
  warning: '⚠️',
  user: '👤',
};
export const Emo = Emojis;
// #endregion

// '☭',
// 'bowl',
// '♛',
// '♠',
// '♣',
// '♥',
// '♦',
// '⚑',
// '⚒',
// '⛑',
// '✿',
// '🎖',
// '🎗',
// '🐿',
// '🕱',
// '🗡',
// '✪',
// ];

// #region NFL Teams **********************************************************

export const NFL_TEAM_NAMES: string[] = [
  'ARI',
  'ATL',
  'BAL',
  'BUF',
  'CAR',
  'CHI',
  'CIN',
  'CLE',
  'DAL',
  'DEN',
  'DET',
  'GB',
  'HOU',
  'IND',
  'JAX',
  'KC',
  'LAC',
  'LAR',
  'LV',
  'MIA',
  'MIN',
  'NE',
  'NO',
  'NYG',
  'NYJ',
  'PIT',
  'PHI',
  'SEA',
  'SF',
  'TB',
  'TEN',
  'WSH',
];

export const NFL_TEAMS: TeamModel[] = [
  {
    teamAbv: 'ARI',
    teamCity: 'Arizona',
    teamName: 'Cardinals',
    teamID: '1',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'ATL',
    teamCity: 'Atlanta',
    teamName: 'Falcons',
    teamID: '2',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'BAL',
    teamCity: 'Baltimore',
    teamName: 'Ravens',
    teamID: '3',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'BUF',
    teamCity: 'Buffalo',
    teamName: 'Bills',
    teamID: '4',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CAR',
    teamCity: 'Carolina',
    teamName: 'Panthers',
    teamID: '5',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CHI',
    teamCity: 'Chicago',
    teamName: 'Bears',
    teamID: '6',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CIN',
    teamCity: 'Cincinnati',
    teamName: 'Bengals',
    teamID: '7',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'CLE',
    teamCity: 'Cleveland',
    teamName: 'Browns',
    teamID: '8',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DAL',
    teamCity: 'Dallas',
    teamName: 'Cowboys',
    teamID: '9',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DEN',
    teamCity: 'Denver',
    teamName: 'Broncos',
    teamID: '10',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'DET',
    teamCity: 'Detroit',
    teamName: 'Lions',
    teamID: '11',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'GB',
    teamCity: 'Green Bay',
    teamName: 'Packers',
    teamID: '12',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'HOU',
    teamCity: 'Houston',
    teamName: 'Texans',
    teamID: '13',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'IND',
    teamCity: 'Indianapolis',
    teamName: 'Colts',
    teamID: '14',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'JAX',
    teamCity: 'Jacksonville',
    teamName: 'Jaguars',
    teamID: '15',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'KC',
    teamCity: 'Kansas City',
    teamName: 'Chiefs',
    teamID: '16',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'LV',
    teamCity: 'Las Vegas',
    teamName: 'Raiders',
    teamID: '17',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'LAC',
    teamCity: 'Los Angeles',
    teamName: 'Chargers',
    teamID: '18',
    division: 'West',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'LAR',
    teamCity: 'Los Angeles',
    teamName: 'Rams',
    teamID: '19',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'MIA',
    teamCity: 'Miami',
    teamName: 'Dolphins',
    teamID: '20',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },

  {
    teamAbv: 'MIN',
    teamCity: 'Minnesota',
    teamName: 'Vikings',
    teamID: '21',
    division: 'North',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NE',
    teamCity: 'New England',
    teamName: 'Patriots',
    teamID: '22',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NO',
    teamCity: 'New Orleans',
    teamName: 'Saints',
    teamID: '23',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NYG',
    teamCity: 'New York',
    teamName: 'Giants',
    teamID: '24',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'NYJ',
    teamCity: 'New York',
    teamName: 'Jets',
    teamID: '25',
    division: 'East',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'PIT',
    teamCity: 'Pittsburgh',
    teamName: 'Steelers',
    teamID: '26',
    division: 'North',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'PHI',
    teamCity: 'Philadelphia',
    teamName: 'Eagles',
    teamID: '27',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'SF',
    teamCity: 'San Francisco',
    teamName: '49ers',
    teamID: '28',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'SEA',
    teamCity: 'Seattle',
    teamName: 'Seahawks',
    teamID: '29',
    division: 'West',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'TB',
    teamCity: 'Tampa Bay',
    teamName: 'Buccaneers',
    teamID: '30',
    division: 'South',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'TEN',
    teamCity: 'Tennessee',
    teamName: 'Titans',
    teamID: '31',
    division: 'South',
    conferenceAbv: 'AFC',
    conference: 'American Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
  {
    teamAbv: 'WSH',
    teamCity: 'Washington',
    teamName: 'Commanders',
    teamID: '32',
    division: 'East',
    conferenceAbv: 'NFC',
    conference: 'National Football Conference',
    logoLgUrl: '',
    logoSmUrl: '',
  },
];

// #endregion
